import { theme } from "gatsby-theme-flow/src/colors";
import DocsetMenu from "../../../../content/components/docset-menu";
import { MenuTitle } from "../../../../content/components/menu";
import TrackingLink from "../../../../content/components/tracking-link";
import { IconGithub, IconDiscord, IconDiscourse } from "gatsby-theme-flow/src/ui/icons";
import * as React from 'react';
export default {
  theme,
  DocsetMenu,
  MenuTitle,
  TrackingLink,
  IconGithub,
  IconDiscord,
  IconDiscourse,
  React
};